import { useEffect } from 'react'
import { Table, Image, message } from 'antd'
import { threeInspectionSchedulingModel } from '../schedulingModel'
import { ISchedulingDetail } from '../schedulingService'
import { DeleteOutlined, FormOutlined } from '@ant-design/icons'
import { Button } from 'antd/lib/radio'
import { getBaseImgLookUrl } from '@/utils/constants'

export function DataTable() {
    const { dataSource, selectedRowKeys, pgCfg, loading, setEditCarVisible, loadData, setSelectedRowKeys, onDelete } = threeInspectionSchedulingModel()

    useEffect(() => {
        loadData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const columns: any = [
        {
            title: '序号',
            width: 60,
            align: 'center',
            render: (_t: any, _r: any, i: number) => i + 1,
        },
        // ...((str) => {
        //     if (str) {
        //         return [
        //             {
        //                 title: '操作',
        //                 width: 140,
        //                 align: "center",
        //                 render: (text, record, index) => <>
        //                 <Button onClick={() =>(hidderButton(record.departureTime)&& setEditCarVisible({visible:true, value:{...record}}))}><FormOutlined style={{cursor: 'pointer'}} /></Button>
        //                 <Button onClick={() =>{hidderButton(record.departureTime)&& onDelete([record])}}><DeleteOutlined style={{cursor: 'pointer'}}/></Button>
        //                 </>
        //             }
        //         ]
        //     } else {
        //         return []
        //     }
        // })(userType=='管理员'),
        {
            title: '操作',
            width: 140,
            align: 'center',
            render: (_t: any, record: ISchedulingDetail) => (
                <>
                    <Button onClick={() => hidderButton(record.departureTime) && setEditCarVisible({ visible: true, value: { ...record } })}>
                        <FormOutlined style={{ cursor: 'pointer' }} />
                    </Button>
                    <Button
                        onClick={() => {
                            onDelete([record])
                        }}
                    >
                        <DeleteOutlined style={{ cursor: 'pointer' }} />
                    </Button>
                </>
            ),
        },
        {
            title: '头像',
            width: 160,
            align: 'center',
            render: (_t: any, records: ISchedulingDetail) =>
                records.md5 ? <Image src={getBaseImgLookUrl(records.md5)} style={{ maxWidth: '50px', maxHeight: '70px' }} /> : null,
        },
        {
            title: '司机',
            width: 120,
            align: 'center',
            dataIndex: 'driverName',
        },
        {
            title: '押运员',
            width: 160,
            align: 'center',
            dataIndex: 'escortName',
        },
        {
            title: '车头',
            width: 160,
            align: 'center',
            dataIndex: 'vehicleNumber',
        },
        {
            title: '挂车',
            width: 160,
            align: 'center',
            dataIndex: 'trailerNumber',
        },
        {
            title: '开始日期',
            width: 160,
            align: 'center',
            dataIndex: 'departureTime',
        },
        {
            title: '结束日期',
            width: 160,
            align: 'center',
            dataIndex: 'departureEndTime',
        },
        {
            title: '路线',
            width: 160,
            align: 'center',
            dataIndex: 'lineName',
        },
    ]

    //点击行选高亮
    const onRow = (record: ISchedulingDetail) => {
        let findObj = selectedRowKeys.find((item) => item.id === record.id)
        if (findObj) {
            let newSelectedRowKeys = selectedRowKeys.filter((item) => item.id !== record.id)
            setSelectedRowKeys(newSelectedRowKeys)
        } else {
            setSelectedRowKeys((origin) => [...origin, record])
        }
    }
    const hidderButton = (val: string) => {
        // 将排班时间的字符串转换为Date对象
        const scheduleDate = new Date(val)
        // 获取当前时间
        const now = new Date()
        // 为了确保比较的准确性，我们可能需要将now的毫秒数清零（可选）
        // 但在这个例子中，由于排班时间是整点整分，我们可以直接比较
        // 比较当前时间和排班时间
        if (now >= scheduleDate) {
            message.warning('排班时间已到或已过!')
            return false
        } else {
            return true
        }
    }

    return (
        <Table
            rowKey={(record) => record?.id as string}
            loading={loading}
            rowSelection={{
                //全部选中时 (存row[])
                onSelectAll: (selected, selectedRows, changeRows) => {
                    selected
                        ? setSelectedRowKeys((origin) => [...origin, ...changeRows])
                        : setSelectedRowKeys((origin) => {
                              let changeRowId = changeRows.map((item) => item.id)
                              return origin.filter((item) => changeRowId.indexOf(item.id) < 0)
                          })
                },
                onSelect: (record) => onRow(record),
                selectedRowKeys: selectedRowKeys.map((item) => item.id as string),
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ['bottomRight'],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                },
                showSizeChanger: true,
            }}
            bordered
            onRow={(record) => ({
                onClick: () => onRow(record),
                onContextMenu: (e) => {
                    e.preventDefault()
                    setSelectedRowKeys([record])
                },
            })}
            scroll={{ x: 'max-content', y: 'calc(100vh - 350px)' }}
        />
    )
}
